import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';

export default function ExtremeDutyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Breadcrumb */}
      <div className="bg-gray-100 py-4">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center gap-2 text-sm">
          <h5 className="font-semibold text-[#333333]">EXTREME DUTY</h5>
          <h5 className="text-[#999999]">/</h5>
          <h5><Link to="/" className="text-[#14B8A6] hover:underline">Home</Link></h5>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Left Column - Images and Video */}
          <div>
            <div className="mb-6">
              <img 
                              src="/images/ED6451.jpg" 
                alt="ED6451" 
                className="w-full h-auto rounded-lg shadow-md"
              />
            </div>
            <div className="mb-6">
              <img 
                              src="/images/664-ED02.jpg" 
                alt="Tree Clipper" 
                className="w-full h-auto rounded-lg shadow-md"
              />
            </div>
            
            
          </div>

          {/* Right Column - Product Info */}
          <div>
            
            
            <h1 className="text-4xl font-bold text-[#333333] mb-4">EXTREME DUTY</h1>
            <h4 className="text-xl font-semibold text-[#666666] mb-2">Model: ED6451</h4>
            <h4 className="text-xl font-semibold text-[#666666] mb-6">Weight: 929 lbs</h4>

            <div className="prose max-w-none mb-8">
              <h2 className="text-2xl font-bold text-[#333333] mb-4">Our Strongest Skid Steer Tree Clipper Head Ever!</h2>
              
              <p className="text-[#666666] mb-4">
                The "Extreme Duty" tree skid steer tree cutter uses our strongest clipper head (664000). The mount has two extra stabilizer bars for a total of five. The rotator also has several extra gussets and is triple walled.
              </p>

              <p className="text-[#666666] mb-4">
                This skid steer land clearing attachment includes a wireless remote to activate the solenoid valve for rotation. Easy to move from one piece of equipment to another without the hassle of a wiring harness – also, no more wires getting tangled in the brush. If your skid steer has electrical outlets you can choose from either the 14 PIN or 8 PIN Connector for controlling the rotation. You will be able to select which button on your control handle will control the rotation feature by determining the location for each pin on the connector. The extra long upper and lower plates add strength to the clipper head. The easy release feature of the 664000 clipper head eliminates limbs and trees from wedging between blades. The self-cleaning side spacers reduces the daily maintenance of cleaning the debris from the sides of the tree clipper.
              </p>

              

              <h2 className="text-2xl font-bold text-[#333333] mb-4">Frequently Asked Questions</h2>

              <p className="mb-3">
                <strong className="text-[#333333]">Q: What types of trees can the Extreme Duty Skid Steer Tree Cutter handle?</strong><br />
                <strong className="text-[#333333]">A:</strong> The Extreme Duty skid steer tree cutter is built to tackle everything from small brush to thick hardwood trees. With its reinforced tree clipper head and powerful cutting mechanism, it can efficiently handle trees up to 12 inches in diameter.
              </p>

              <p className="mb-3">
                <strong className="text-[#333333]">Q: Is this tree clipper compatible with all skid steers?</strong><br />
                <strong className="text-[#333333]">A:</strong> Yes! This skid steer land clearing attachment is designed for universal compatibility. It includes options for both 14-PIN and 8-PIN connectors, allowing you to integrate it with most skid steer models. The wireless remote option also makes switching between machines quick and hassle-free.
              </p>

              <p className="mb-6">
                <strong className="text-[#333333]">Q: How does the self-cleaning feature reduce maintenance?</strong><br />
                <strong className="text-[#333333]">A:</strong> The self-cleaning side spacers prevent debris from accumulating around the blades, reducing the time you spend on daily maintenance. This feature keeps the tree clipper functioning smoothly, ensuring consistent performance in tough conditions.
              </p>
            </div>

            <hr className="border-gray-300 mb-6" />

            {/* Features Accordion */}
            <div className="mb-8">
              <details className="group" open>
                <summary className="flex items-center justify-between cursor-pointer list-none p-4 bg-[#f8f8f8] rounded-lg font-bold text-[#333333]">
                  <span>FEATURES</span>
                  <i className="ri-arrow-down-s-line text-2xl group-open:rotate-180 transition-transform"></i>
                </summary>
                <div className="p-4 bg-white">
                  <ul className="list-disc list-inside space-y-2 text-[#666666]">
                    <li>664000 Clipper Head</li>
                    <li>Fully plumbed with hoses/hose wrap, couplers, solenoid valve and valve guard</li>
                    <li>Wireless Remote – transmitter, receiver, battery, charger, steel storage box</li>
                    <li>Ground Level Cutting or Power Rotate up to 110 degrees to trim limbs</li>
                    <li>Maximum Cut Between 9″ and 12″</li>
                    <li>Cuts all Wood ~ DEAD OR ALIVE!</li>
                    <li>Limb Guard</li>
                  </ul>
                </div>
              </details>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col gap-4 mb-8">
              <a 
                href="/contact" 
                className="bg-[#14B8A6] text-white text-center px-8 py-3 font-bold hover:bg-[#0f9b8e] transition-colors whitespace-nowrap"
              >
                Call Us Now
              </a>
              
              
            </div>
          </div>
        </div>
      </div>

      

      {/* Disclaimer */}
      <div className="bg-white py-12">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h3 className="text-2xl font-bold text-[#333333] mb-4">SOLVING TREE & BRUSH PROBLEMS SINCE 1992!</h3>
          <p className="text-[#666666]">
            All products have been carefully manufactured and tested. Should our product prove defective, or appear to be, please discontinue use immediately and contact us. Not responsible for any damage or claims beyond the selling price of the product. No returns allowed without express written consent of company.
          </p>
        </div>
      </div>

      
    </div>
  );
}
